module.exports = __webpack_public_path__ + "static/media/message-read.7ef008d8.svg";